module.exports = __webpack_public_path__ + "static/media/kestrel-mark.d86a1e6a.svg";